import { put } from "redux-saga/effects"

import { setLoginNotification } from "../../actions"

export default function* responseFailFormActions(
  errorMsg,
  setStatus = null,
  statusMsg,
  setSubmitting = null
) {
  yield put(setLoginNotification(errorMsg))
  if (setStatus) {
    setStatus({
      errorMsg: statusMsg
    })
    setSubmitting(false)
  }
  return
}
